import { TireSeason, TireSeasonLabels } from '@navio/nsdk';
import {
  CAR_WHEEL_ALL_SEASON_VALUE,
  CAR_WHEEL_SUMMER_VALUE,
  CAR_WHEEL_WINTER_VALUE,
  type CarWheelSeasonValue
} from 'noddi-types';
import type { FilterOption } from 'noddi-ui-web';

// Map TireSeason to numeric values for filter compatibility
const TireSeasonToNumeric: Record<TireSeason, CarWheelSeasonValue> = {
  [TireSeason.SUMMER]: CAR_WHEEL_SUMMER_VALUE,
  [TireSeason.WINTER]: CAR_WHEEL_WINTER_VALUE,
  [TireSeason.ALL_SEASON]: CAR_WHEEL_ALL_SEASON_VALUE
};

export const CAR_WHEEL_SEASON_FILTER_OPTIONS: FilterOption<CarWheelSeasonValue>[] = Object.entries(
  TireSeasonToNumeric
).map(([key, value]) => ({
  label: TireSeasonLabels[key as TireSeason],
  value
}));

/** Title, description and visible options of this filter, for the builder next to its options. */
export const CAR_WHEEL_SEASON_FILTER_TEXT = { title: 'Seasons', description: 'Filter by car wheel season' };
